import { type WalkthroughStatus } from "~/store/walkthroughSlice";
import { type WalkthroughDefinition } from "~/walkthroughs/types";

export interface TourOfferInput {
	helpOn: boolean;
	isLoaded: boolean;
	isWideScreen: boolean;
	offered: (tourId: string) => boolean;
	status: WalkthroughStatus;
	tours: WalkthroughDefinition[];
}

const pickTourOffer = ({
	helpOn,
	isLoaded,
	isWideScreen,
	offered,
	status,
	tours
}: TourOfferInput): WalkthroughDefinition | undefined => {
	if (!helpOn || !isWideScreen || !isLoaded || status === "running") return undefined;
	return tours.find((tour) => !offered(tour.id));
};

export default pickTourOffer;
